import styled from "styled-components/macro";

export const VendorHeaderRow = styled.div`
  display: flex;
  width: 100%;
  background-color: #fafafa;
  box-sizing: border-box;
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`;

export const VendorPropertyRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  height: 120px;
  padding: 18px 24px;
`;

export const SubsectionWrapper = styled.div`
  & .subsection span {
    color: #000000 !important;
  }
`;
